import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSwitcher = ({ compact = false }) => {
  const { language, changeLanguage } = useLanguage();

  const handleToggle = () => {
    const newLanguage = language === 'es' ? 'en' : 'es';
    changeLanguage(newLanguage);
  };

  if (compact) {
    // Compact version for mobile
    return (
      <button
        onClick={handleToggle}
        className="flex items-center bg-slate-800/80 hover:bg-slate-700/80 rounded-full border border-purple-500/30 hover:border-purple-500/50 transition-all duration-300 px-3 py-2 min-h-[44px] min-w-[44px] focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:ring-offset-2 focus:ring-offset-slate-900"
        aria-label="Cambiar idioma / Change language"
        style={{ height: '36px' }}
      >
        <div className="flex items-center space-x-1">
          <span 
            className={`text-xs font-semibold transition-all duration-300 ${
              language === 'es' ? 'text-white' : 'text-white/70'
            }`}
            style={{ 
              textDecoration: language === 'es' ? 'underline' : 'none',
              fontWeight: language === 'es' ? '700' : '500'
            }}
          >
            ES
          </span>
          <span className="text-white/40 text-xs">|</span>
          <span 
            className={`text-xs font-semibold transition-all duration-300 ${
              language === 'en' ? 'text-white' : 'text-white/70'
            }`}
            style={{ 
              textDecoration: language === 'en' ? 'underline' : 'none',
              fontWeight: language === 'en' ? '700' : '500'
            }}
          >
            EN
          </span>
        </div>
      </button>
    );
  }

  // Desktop version - same as current LanguageSelector but simpler
  return (
    <div className="flex items-center bg-slate-800/50 hover:bg-slate-700/50 rounded-full border border-purple-500/20 hover:border-purple-500/40 transition-all duration-300 px-4 py-2">
      <button
        onClick={() => changeLanguage('es')}
        className={`px-3 py-1 rounded-l-full text-sm font-medium transition-all duration-300 ${
          language === 'es' 
            ? 'text-white bg-purple-600/30 font-bold' 
            : 'text-white/70 hover:text-white hover:bg-white/5'
        }`}
        aria-label="Español"
      >
        🇪🇸 ES
      </button>
      <div className="w-px h-4 bg-white/20"></div>
      <button
        onClick={() => changeLanguage('en')}
        className={`px-3 py-1 rounded-r-full text-sm font-medium transition-all duration-300 ${
          language === 'en' 
            ? 'text-white bg-purple-600/30 font-bold' 
            : 'text-white/70 hover:text-white hover:bg-white/5'
        }`}
        aria-label="English"
      >
        🇺🇸 EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;